declare namespace $ {

	type $mol_check_box__title_shm_ba_user_settings_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_user_settings_2 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['mentions_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_ba_user_settings_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_user_settings_4 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['mention_stats_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_ba_user_settings_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_user_settings_6 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_string__keyboard_shm_ba_user_settings_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__hint_shm_ba_user_settings_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_ba_user_settings_9 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_task_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_user_settings_10 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_task_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_user_settings_11 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_user_settings['wordstat_task_limit_commit'] > ): ReturnType< $shm_ba_user_settings['wordstat_task_limit_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['wordstat_task_limit_keydown'] > ): ReturnType< $shm_ba_user_settings['wordstat_task_limit_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_13 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Wordstat_task_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_ba_user_settings_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__hint_shm_ba_user_settings_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_ba_user_settings_16 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_hourly_request_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_user_settings_17 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_hourly_request_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_user_settings_18 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_user_settings['wordstat_hourly_request_limit_commit'] > ): ReturnType< $shm_ba_user_settings['wordstat_hourly_request_limit_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['wordstat_hourly_request_limit_keydown'] > ): ReturnType< $shm_ba_user_settings['wordstat_hourly_request_limit_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_20 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Wordstat_hourly_request_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_ba_user_settings_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__hint_shm_ba_user_settings_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_ba_user_settings_23 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_regular_daily_task_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_user_settings_24 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_regular_daily_task_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_user_settings_25 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_user_settings['wordstat_regular_daily_task_limit_commit'] > ): ReturnType< $shm_ba_user_settings['wordstat_regular_daily_task_limit_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['wordstat_regular_daily_task_limit_keydown'] > ): ReturnType< $shm_ba_user_settings['wordstat_regular_daily_task_limit_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_27 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Wordstat_regular_daily_task_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_ba_user_settings_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__value_shm_ba_user_settings_29 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_query_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_user_settings_30 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_query_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_user_settings_31 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_user_settings['wordstat_query_limit_commit'] > ): ReturnType< $shm_ba_user_settings['wordstat_query_limit_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['wordstat_query_limit_keydown'] > ): ReturnType< $shm_ba_user_settings['wordstat_query_limit_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_33 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Wordstat_query_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_ba_user_settings_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__value_shm_ba_user_settings_35 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_subtask_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_user_settings_36 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['wordstat_subtask_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_user_settings_37 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_user_settings['wordstat_subtask_limit_commit'] > ): ReturnType< $shm_ba_user_settings['wordstat_subtask_limit_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['wordstat_subtask_limit_keydown'] > ): ReturnType< $shm_ba_user_settings['wordstat_subtask_limit_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_39 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Wordstat_subtask_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_ba_user_settings_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_user_settings_41 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['agent_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_string__value_shm_ba_user_settings_42 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['agent_url_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_user_settings_43 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['agent_url_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_user_settings_44 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_user_settings['agent_url_commit'] > ): ReturnType< $shm_ba_user_settings['agent_url_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['agent_url_keydown'] > ): ReturnType< $shm_ba_user_settings['agent_url_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_46 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Agent_url'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_password__value_shm_ba_user_settings_47 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['agent_token_draft'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_password__submit_shm_ba_user_settings_48 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['agent_token_commit'] >
		,
		ReturnType< $mol_password['submit'] >
	>
	type $mol_password__event_shm_ba_user_settings_49 = $mol_type_enforce<
		({ 
			focusout( next?: ReturnType< $shm_ba_user_settings['agent_token_commit'] > ): ReturnType< $shm_ba_user_settings['agent_token_commit'] >,
			keydown( next?: ReturnType< $shm_ba_user_settings['agent_token_keydown'] > ): ReturnType< $shm_ba_user_settings['agent_token_keydown'] >,
		})  & ReturnType< $mol_password['event'] >
		,
		ReturnType< $mol_password['event'] >
	>
	type $mol_labeler__title_shm_ba_user_settings_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_user_settings_51 = $mol_type_enforce<
		ReturnType< $shm_ba_user_settings['Agent_token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_ba_user_settings_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_user_settings extends $mol_view {
		mentions_enabled( next?: boolean ): boolean
		Mentions_enabled( ): $mol_check_box
		mention_stats_enabled( next?: boolean ): boolean
		Mention_stats_enabled( ): $mol_check_box
		wordstat_enabled( next?: boolean ): boolean
		Wordstat_enabled( ): $mol_check_box
		wordstat_task_limit_draft( next?: string ): string
		wordstat_task_limit_commit( next?: any ): any
		wordstat_task_limit_keydown( next?: any ): any
		Wordstat_task_limit( ): $mol_string
		Wordstat_task_limit_label( ): $mol_labeler
		wordstat_hourly_request_limit_draft( next?: string ): string
		wordstat_hourly_request_limit_commit( next?: any ): any
		wordstat_hourly_request_limit_keydown( next?: any ): any
		Wordstat_hourly_request_limit( ): $mol_string
		Wordstat_hourly_request_limit_label( ): $mol_labeler
		wordstat_regular_daily_task_limit_draft( next?: string ): string
		wordstat_regular_daily_task_limit_commit( next?: any ): any
		wordstat_regular_daily_task_limit_keydown( next?: any ): any
		Wordstat_regular_daily_task_limit( ): $mol_string
		Wordstat_regular_daily_task_limit_label( ): $mol_labeler
		wordstat_query_limit_draft( next?: string ): string
		wordstat_query_limit_commit( next?: any ): any
		wordstat_query_limit_keydown( next?: any ): any
		Wordstat_query_limit( ): $mol_string
		Wordstat_query_limit_label( ): $mol_labeler
		wordstat_subtask_limit_draft( next?: string ): string
		wordstat_subtask_limit_commit( next?: any ): any
		wordstat_subtask_limit_keydown( next?: any ): any
		Wordstat_subtask_limit( ): $mol_string
		Wordstat_subtask_limit_label( ): $mol_labeler
		agent_enabled( next?: boolean ): boolean
		Agent_enabled( ): $mol_check_box
		agent_url_draft( next?: string ): string
		agent_url_commit( next?: any ): any
		agent_url_keydown( next?: any ): any
		Agent_url( ): $mol_string
		Agent_url_label( ): $mol_labeler
		agent_token_draft( next?: string ): string
		agent_token_commit( next?: any ): any
		agent_token_keydown( next?: any ): any
		Agent_token( ): $mol_password
		Agent_token_label( ): $mol_labeler
		Agent_settings( ): $mol_view
		settings_rows( ): readonly(any)[]
		user_id( ): string
		user_data( ): any
		scope( ): string
		sub( ): ReturnType< $shm_ba_user_settings['settings_rows'] >
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map